"use client";

import { Card } from "@workspace/ui/components/card";
import { Skeleton } from "@workspace/ui/components/skeleton";

export function ShowDiscoverySkeleton() {
	return (
		<Card className="overflow-hidden">
			<div className="flex gap-3 p-3">
				{/* Show image - 64x64px square thumbnail */}
				<div className="relative flex-shrink-0 overflow-hidden rounded-lg">
					<div className="h-16 w-16">
						<Skeleton className="h-full w-full rounded-lg" />
					</div>
				</div>

				{/* Show info */}
				<div className="min-w-0 flex-1">
					{/* Main content area */}
					<div className="flex items-start justify-between gap-2">
						<div className="min-w-0 flex-1">
							{/* Artist name */}
							<Skeleton className="h-5 w-2/3" />

							{/* Venue */}
							<div className="mt-0.5 flex items-center gap-1.5">
								<Skeleton className="h-3 w-3 flex-shrink-0" />
								<Skeleton className="h-3 w-32" />
							</div>

							{/* Location - City, State */}
							<div className="mt-0.5 flex items-center gap-1.5">
								<Skeleton className="h-3 w-3 flex-shrink-0" />
								<Skeleton className="h-3 w-24" />
							</div>

							{/* Date and Time */}
							<div className="mt-0.5 flex flex-col gap-0.5">
								<div className="flex items-center gap-1.5">
									<Skeleton className="h-3 w-3 flex-shrink-0" />
									<Skeleton className="h-3 w-20" />
								</div>
								<div className="flex items-center gap-1.5">
									<Skeleton className="h-3 w-3 flex-shrink-0" />
									<Skeleton className="h-3 w-16" />
								</div>
							</div>
						</div>

						{/* Want to Go button and Facepile */}
						<div className="relative z-10 flex flex-col items-end justify-between self-stretch">
							<div className="flex">
								<Skeleton className="h-8 w-20 rounded-l-md rounded-r-none" />
								<Skeleton className="h-8 w-6 rounded-l-none rounded-r-md" />
							</div>
							<div className="-space-x-2 flex">
								<Skeleton className="h-6 w-6 rounded-full border-2 border-background" />
								<Skeleton className="h-6 w-6 rounded-full border-2 border-background" />
								<Skeleton className="h-6 w-6 rounded-full border-2 border-background" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</Card>
	);
}
